import { render, staticRenderFns } from "./Colel.vue?vue&type=template&id=3d516d7e&"
import script from "./Colel.vue?vue&type=script&lang=js&"
export * from "./Colel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports